import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { Badge, Pagination } from "react-bootstrap";

const AccessoriesItem = ({
  accessories,
  onEdit,
  onDelete,
  selectedItems = [],
  onSelectItem,
  onSelectAll,
  totalItems,
  totalPages,
  currentPage,
  itemsPerPage,
  goToPage,
  isStart,
  isEnd,
  getNext,
  getPrev,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDate = (date) => {
    if (date != undefined) {
      try {
        var datetime = new Date(date.toDate()).toLocaleDateString();
        return datetime;
      } catch {
        var newDate = new Date(date);
        var hours = newDate.getHours() + 7;
        newDate = new Date(newDate.setHours(hours));
        var newString = newDate.toLocaleDateString();
        return newString;
      }
    } else {
      return "";
    }
  };

  const getStockStatusVariant = (stock, minStock) => {
    if (stock <= 0) return "danger dark";
    if (minStock && stock <= minStock) return "warning dark";
    return "success light";
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <table className="table mb-0 table-striped">
                  <thead>
                    <tr>
                      <th>
                        <input
                          type="checkbox"
                          checked={selectedItems.length === accessories.length && accessories.length > 0}
                          onChange={onSelectAll}
                        />
                      </th>
                      <th>#</th>
                      <th>Item Code</th>
                      <th>Category</th>
                      <th>Item Name</th>
                      <th>Brand</th>
                      <th>Size</th>
                      <th>Stock</th>
                      <th>Unit Price</th>
                      <th>Status</th>
                      <th>Location</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody id="accessories-table">
                    {!loading ? (
                      accessories.map((accessory, index) => {
                        const stockVariant = getStockStatusVariant(
                          accessory.stockQuantity,
                          accessory.minimumStock
                        );
                        
                        let statusVariant = "";
                        if (accessory.status === "Active") {
                          statusVariant = "success light";
                        } else if (accessory.status === "Out of Stock") {
                          statusVariant = "danger dark";
                        } else if (accessory.status === "Discontinued") {
                          statusVariant = "secondary dark";
                        }

                        return (
                          <tr key={accessory.id} className="btn-reveal-trigger">
                            <td className="py-2">
                              <input
                                type="checkbox"
                                checked={selectedItems.includes(accessory.id)}
                                onChange={() => onSelectItem && onSelectItem(accessory.id)}
                              />
                            </td>
                            <td className="py-1">
                              {index + 1 + (currentPage - 1) * itemsPerPage}
                            </td>
                            <td className="py-2">{accessory.itemCode}</td>
                            <td className="py-2">{accessory.category}</td>
                            <td className="py-2">{accessory.itemName}</td>
                            <td className="py-2">{accessory.brand}</td>
                            <td className="py-2">{accessory.size}</td>
                            <td className="py-2">
                              <Badge variant={stockVariant}>
                                {accessory.stockQuantity}
                              </Badge>
                            </td>
                            <td className="py-2">
                              {accessory.unitPrice ? `฿${accessory.unitPrice}` : "-"}
                            </td>
                            <td className="py-2">
                              <Badge variant={statusVariant}>{accessory.status}</Badge>
                            </td>
                            <td className="py-2">{accessory.location || "-"}</td>
                            <td className="py-2 text-right">
                              <div className="d-flex">
                                <Link
                                  className="btn btn-info shadow btn-xs sharp mr-2"
                                  to="#"
                                  onClick={() => onEdit(accessory.id)}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Edit accessory"
                                >
                                  <i className="fa fa-pencil"></i>
                                </Link>
                                <Link
                                  to="#"
                                  className="btn btn-danger shadow btn-xs sharp"
                                  onClick={() => onDelete(accessory.id)}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Delete accessory"
                                >
                                  <i className="fa fa-trash"></i>
                                </Link>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center">
                          <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="dataTables_info">
                  Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                  {totalItems < currentPage * itemsPerPage
                    ? totalItems
                    : currentPage * itemsPerPage}{" "}
                  of {totalItems} entries
                </div>
                <div className="dataTables_paginate paging_simple_numbers">
                  <Pagination
                    className="pagination-primary pagination-circle"
                    size="lg"
                  >
                    <Pagination.Prev onClick={getPrev} disabled={isStart} />
                    {pageNumbers.map((number) => (
                      <Pagination.Item
                        key={number}
                        active={number === currentPage}
                        onClick={() => goToPage(number)}
                      >
                        {number}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next onClick={getNext} disabled={isEnd} />
                  </Pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AccessoriesItem;
